// StationPanelSmall – dlaždice (grid card): foto size=m, gh_id, název, typ, souřadnice, výška, obs_type, tlačítko Detail
import { useNavigate } from 'react-router-dom'
import { Button, Card, Chip } from '@heroui/react'
import { StationPhoto } from '../StationPhoto'

function getDistinctObsTypes(station) {
  if (!station.observation) return []
  return [...new Set(station.observation.map(o => o.obs_type))]
}

export function StationPanelSmall({ station, onDetailClick, onClose }) {
  const navigate = useNavigate()

  const handleDetail = () => {
    if (onDetailClick) onDetailClick(station)
    else navigate(`/station/${station.gh_id}`)
  }

  const obsTypes = getDistinctObsTypes(station)

  return (
    <Card className="flex flex-col h-full min-h-[200px] relative">
      <StationPhoto
        ghId={station.gh_id}
        size="m"
        className="w-full h-[150px] rounded-t-xl"
        alt={station.name}
      />
      {onClose && (
        <button
          type="button"
          className="absolute top-1.5 right-1.5 z-10 w-6 h-6 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-gray-600 hover:text-gray-900 shadow text-sm leading-none"
          title="Zrušit výběr"
          aria-label="Zrušit výběr"
          onClick={() => onClose(station)}
        >
          ✕
        </button>
      )}
      <Card.Content className="flex flex-col gap-1 p-3 flex-1">
        <div className="flex items-start justify-between gap-1">
          <span className="text-xs font-mono text-muted">{station.gh_id}</span>
          <span className="text-xs bg-gray-100 px-1 rounded text-gray-600">{station.station_type}</span>
        </div>
        <Card.Title className="text-sm leading-tight line-clamp-2">{station.name}</Card.Title>
        {station.qual && (
          <span className="text-xs text-gray-500">{station.qual}</span>
        )}
        <div className="text-xs text-muted mt-1">
          <span>{station.latitude?.toFixed(4)}°N {station.longitude?.toFixed(4)}°E</span>
        </div>
        {station.elevation != null && (
          <div className="text-xs text-muted">{station.elevation} m n.m.</div>
        )}
        {obsTypes.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-1">
            {obsTypes.map(t => (
              <Chip key={t} size="sm" variant="flat" className="text-xs h-4 px-1">{t}</Chip>
            ))}
          </div>
        )}
      </Card.Content>
      <Card.Footer className="p-2 pt-0">
        <Button size="sm" variant="secondary" className="w-full" onPress={handleDetail}>
          Detail
        </Button>
      </Card.Footer>
    </Card>
  )
}